import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const PaymentMovementsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function usePaymentMovementsUIContext () {
    return useContext(PaymentMovementsUIContext);
}

export const PaymentMovementsUIConsumer = PaymentMovementsUIContext.Account;

export function PaymentMovementsUIProvider ({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [paymentMovements, setPaymentMovements] = useState([]);
    const [fetchData, setFetchData] = useState(false);

    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        paymentMovements,
        setPaymentMovements,
        fetchData,
        setFetchData
    };

    return <PaymentMovementsUIContext.Provider value={value}>{children}</PaymentMovementsUIContext.Provider>;
}
